import React, { useRef, useState } from 'react';
import { BaseComponentProps } from '@/pages/benchmark/types/commom';
import classNames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import './index.scss';

interface IGTDRTableCardProps extends BaseComponentProps {
  activeTabs?: string[];
  columns: any[];
  data: any[];
  setTableData: any;
  closeColumn?: (item: any, index: number) => void;
}

const GTDRTableCard = (props: IGTDRTableCardProps) => {
  const {
    style,
    className,
    columns = [],
    data = [],
    setTableData,
    closeColumn,
  } = props;

  const headerDomRef = useRef<HTMLDivElement>(null);
  const bodyDomRef = useRef<HTMLDivElement>(null);

  const [scrollLeft, setScrollLeft] = useState(0);

  const toggleCategory = (index: number) => {
    const newData = data.map((item: any, i: number) => {
      if (index === i) {
        item.isOpen = !item.isOpen;
      }
      return item;
    });
    setTableData(newData);
  };

  const bodyScroll = (e: any) => {
    const { scrollLeft } = e.target;
    headerDomRef.current?.scrollTo({ left: scrollLeft });
    setScrollLeft(scrollLeft);
  };

  const headerScroll = (e: any) => {
    const { scrollLeft } = e.target;
    bodyDomRef.current?.scrollTo({ left: scrollLeft });
    setScrollLeft(scrollLeft);
  };

  return (
    <div
      className={classNames('dbd-benchmark-gtdr-table-container', className, {
        'dbd-benchmark-gtdr-table-scoll-container': scrollLeft > 0,
      })}
      style={style}
    >
      <div
        className="dbd-benchmark-gtdr-table-hd"
        ref={headerDomRef}
        onScroll={headerScroll}
      >
        <div className="dbd-benchmark-gtdr-table-box">
          <div className="dbd-benchmark-gtdr-table-hd-tr">
            {columns?.map((item: any, index: number) => {
              const { header, key, canClose } = item || {};
              return (
                <div key={key} className="dbd-benchmark-gtdr-table-hd-th">
                  {header}
                  {canClose && index !== 1 && (
                    <i
                      className="dbd-benchmark-competitor-table-close-icon"
                      onClick={() => closeColumn?.(item, index)}
                    >
                      <SvgIcon type="clear-icon" />
                    </i>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div
        className="dbd-benchmark-gtdr-table-bd"
        ref={bodyDomRef}
        onScroll={bodyScroll}
      >
        <div className="dbd-benchmark-gtdr-table-box">
          <div className="dbd-benchmark-gtdr-table-content-container">
            {data?.map((item: any, index: number) => {
              const { title, children = [], isOpen = true } = item || {};

              return (
                <div key={title}>
                  <div
                    className="dbd-benchmark-gtdr-table-content-title"
                    onClick={() => toggleCategory(index)}
                  >
                    <i style={{ transform: isOpen ? '' : 'rotate(-90deg)' }}>
                      <SvgIcon type="fill-icon-arrow" />
                    </i>
                    <span className="dbd-benchmark-gtdr-table-content-title-text">
                      {title}
                    </span>
                  </div>
                  <div
                    className="dbd-benchmark-gtdr-table-content"
                    style={{ display: isOpen ? '' : 'none' }}
                  >
                    {children?.map((rowData: any, index: number) => {
                      const { className, style } = rowData;
                      return (
                        <div
                          key={index}
                          className="dbd-benchmark-gtdr-table-content-tr"
                        >
                          {columns?.map((item: any) => {
                            const { key, render } = item;
                            return (
                              <div
                                key={key}
                                className={classNames(
                                  className,
                                  'dbd-benchmark-gtdr-table-content-td',
                                )}
                                style={style}
                              >
                                {render ? (
                                  render(rowData[key], rowData)
                                ) : (
                                  <div className="dbd-benchmark-gtdr-table-content-td-div">
                                    {rowData[key] || '-'}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GTDRTableCard;
